import React from "react";
import { useObserver } from "mobx-react";
import { lighten } from "polished";
import { Props } from "./CommentBox";
import { CommentBoxStore } from "./CommentBoxStore";
import { ControlsRow } from "@common/ControlsRow";
import { makeStyles } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import BasicSelect from "@components/Select";

type LeftControlsProps = {
  store: CommentBoxStore;
  commentProps: Props<any>;
};

export function LeftControls(props: LeftControlsProps) {
  const { commentProps } = props;
  const classes = useStyle({});

  return useObserver(() => {
    if (commentProps?.onFilter && commentProps?.filterOptions) {
      const options = commentProps.filterOptions.map((x) => ({
        label: locale.consultantEventTypes[x],
        value: x
      }));

      type Options = typeof options;

      return (
        <ControlsRow fullWidth>
          <BasicSelect
            className={classes.eventFilter}
            fullWidth
            multi
            options={options}
            sortOptions={true}
            optionType={"checkbox"}
            onChange={commentProps.onFilter}
            placeholder={`${locale.filterOnRange(0, options.length)}:`}
            filterOptionsWhenTyping={false}
            onInputKeyDown={(e) => e.preventDefault()}
            valueComponent={(props) => {
              const value = props.value as any as Options[0];
              const values = props.values as Options;

              // show only one formatted value
              const filterValue =
                values[0]?.value === value?.value
                  ? `${locale.filterOnRange(values.length, options.length)}:`
                  : null;

              return (
                filterValue && <span className="Select-placeholder">{filterValue}</span>
              );
            }}
            value={commentProps.selectedFilter || []}
            disableUnderline
          />
        </ControlsRow>
      );
    }

    return null;
  });
}

const useStyle = makeStyles((theme) => ({
  item: {
    padding: "0px 8px"
  },

  userSelected: {
    marginRight: "4px",
    backgroundColor: lighten(0.2, theme.palette.primary.main)
  },

  eventFilter: {
    minWidth: theme.spacing(32),
    cursor: "pointer",

    "& input": { width: "0 !important" },
    "& .Select-placeholder": {
      margin: 0,
      opacity: 1
    }
  },

  assignWrap: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },

  userAssignSection: {
    maxHeight: "58px",
    marginRight: "10px",
    paddingTop: "10px",
    display: "flex",
    "& > button": {
      marginRight: "10px"
    }
  },

  teamAssignSection: {
    display: "flex",
    width: "100%",
    marginLeft: "25px"
  }
}));
